/**
 * Created by sunjinyu on 2018/11/12.
 */
export default {
  /**
   * 订单详情
   */
  ORDER_DETAILS (state, data) {
    state.orderDetails = data;
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js